<template>
  <div
    class="content-card"
    :class="{
      'content-card__video-only': article.vimeo_id && !article.description,
    }"
  >
    <div
      v-if="
        article.vimeo_id ||
        article.youtube_id ||
        article.preview_urls ||
        article.slides.length
      "
      class="content-card__side content-card__side-preview"
    >
      <div :style="sideStyles" class="content-card__side-preview-bg"></div>
      <v-responsive
        v-if="article.vimeo_id"
        class="content-card__video"
        :aspect-ratio="480 / 280"
      >
        <VimeoPlayer :vimeoId="article.vimeo_id" />
      </v-responsive>
      <v-responsive
        v-else-if="article.youtube_id"
        class="content-card__video"
        :aspect-ratio="480 / 280"
      >
        <YoutubePlayer :youtubeId="article.youtube_id" />
      </v-responsive>

      <div
        v-else-if="article.slides.length == 0 && article.preview_urls.large"
        :style="sideStyles"
        class="content-card__side-preview-fg"
      ></div>
      <swiper
        ref="instance"
        class="content-card__slider"
        :options="swiperOption"
        v-else-if="article.slides.length && sliderInited"
      >
        <swiper-slide v-for="slide in article.slides" :key="slide.id">
          <div
            class="content-card__slide"
            :style="{ backgroundImage: `url(${slide.preview_urls.large})` }"
          ></div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div
      class="content-card__side content-card__side--scroll"
      v-if="!article.vimeo_id && !article.youtube_id"
    >
      <div class="content-card__title">
        {{ article.title }}
      </div>
      <div class="content-card__description" v-html="article.description"></div>
      <v-btn
        rounded
        outlined
        color="#C4C4C4"
        v-if="
          article.content_link_type == 'download_reference' ||
          article.state == 'attachment'
        "
        :href="
          article.content_link ||
          article.attachment_url ||
          article.preview_urls.original
        "
        :target="article.state == 'attachment' ? false : '_blank'"
        :download="article.state == 'attachment' ? article.title : false"
      >
        <span style="margin-right: 5px">{{
          article.content_link_text || "download"
        }}</span>
        <v-icon style="top: 2px" color="#C4C4C4" size="16">$download</v-icon>
      </v-btn>
      <v-btn
        large
        color="jude_lightred"
        v-else-if="
          article.content_link_type == 'button' && article.content_link
        "
        :href="article.content_link || article.preview_urls.original"
        target="_blank"
      >
        {{ article.content_link_text || "Open Link" }}
      </v-btn>
      <br />
      <br />
    </div>

    <div class="content-card__bottom" v-else>
      <div class="content-card__title">
        {{ article.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleContent",
  props: {
    article: Object,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      sliderInited: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.sliderInited = true;
    }, 300);
  },
  computed: {
    sideStyles() {
      let res = {};

      if (this.article.slides.length == 0) {
        res.backgroundImage = `url(${this.background})`;
      }

      if (this.article?.content_link_type == "download_reference") {
        res = {
          ...res,
          filter: "none",
          backgroundSize: "contain",
        };
      }

      return res;
    },
    background() {
      return this.article.expanded_preview_urls?.original;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-button-prev,
.swiper-button-next {
  color: $primary;
}

.content-card {
  &__video-only {
    flex-direction: column;
  }
  &__bottom {
    .content-card__title {
      margin: 0.5em;
    }
  }
  &__slide {
    height: 100%;
    width: 100%;
    background-position: center;
    background-size: contain;
  }
}

.content-card__side::v-deep .swiper-container {
  height: 100%;
  width: 100%;
}
.content-card__side::v-deep .v-responsive__content {
  height: 100%;
}
</style>
